import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Register from "../pages/register/page";
import Login from "../pages/login/page";
import Support from "../pages/support/page";
import Pricing from "../pages/pricing/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/register", element: <Register /> },
  { path: "/login", element: <Login /> },
  { path: "/support", element: <Support /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
